var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon",class:_vm.classes,style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.src)}})}
var staticRenderFns = []

export { render, staticRenderFns }